import { ReactElement, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'

import { AddIcon, GroupIcon } from 'src/v3/core/icons'

import theme from 'src/theme'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import SelectLinkedService from 'src/v3/manage/components/linked-service'
import { maxListWidth } from 'src/v3/manage/constants'
import Loading from 'src/v3/components/loading'
import {
  fetchGroups,
  selectActiveLinkedService,
  selectGroupsStatus,
  selectGroupsByLinkedService,
} from '../manage.slice'
import EntityList from '../components/entity-list'

let deleteUserGroup = (groupId: string) =>
  axios.delete<unknown>(`/api/v2/manage/group?id=${groupId}`)

export default (): ReactElement => {
  let navigate = useNavigate()
  let dispatch = useAppDispatch()

  let activeLinkedService = useAppSelector(selectActiveLinkedService)
  let groups = useAppSelector(selectGroupsByLinkedService(activeLinkedService))
  let groupsStatus = useAppSelector(selectGroupsStatus)

  useEffect(() => {
    if (groupsStatus === 'uninitialized') {
      dispatch(fetchGroups())
    }
  }, [groupsStatus])

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          p: 2,
          maxWidth: maxListWidth,
          bgcolor: 'background.paper',
          margin: 'auto',
        }}
      >
        <div className="flex items-center justify-center my-2">
          <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
            <GroupIcon />
          </Avatar>
          <Typography
            variant="h4"
            className="pl-2"
            style={{
              fontFamily: 'smileAndWave',
            }}
          >
            Groups
          </Typography>
        </div>
        <div className="flex justify-center">
          <Typography
            paragraph
            className="px-2 d-inline"
            color="text.secondary"
          >
            Create, view, edit, and delete member groups
          </Typography>
        </div>
        <SelectLinkedService linkedServiceID={activeLinkedService} />
        <Box>
          <EntityList
            entities={groups as any[]}
            route={'/manage/groups'}
            onDelete={(id: string) =>
              deleteUserGroup(id).then(() => dispatch(fetchGroups()))
            }
          />
          <div className="flex justify-center mt-4">
            <Button
              variant="contained"
              size="large"
              startIcon={<AddIcon />}
              disabled={activeLinkedService === 'unselected'}
              onClick={() => navigate('/manage/groups/create')}
            >
              Create
            </Button>
          </div>
        </Box>
      </Card>
      <Loading entities={[groupsStatus]} />
    </>
  )
}
